import React from "react";

const Button = ({ children, loading = false, ...rest }) => (
  <button className="button is-primary" {...rest}>
    {children}
    {loading ? <span className="tiny-spinner" /> : <span className="arrow" />}
  </button>
);

export default Button;
